import {
  RESET_FEATURE_FLAGS,
  SET_CUSTOMER_FLAGS_KEY,
  SET_FEATURE_FLAGS,
} from '@/store/mutation-types/featureFlagMutations'

const DEFAULT_FLAGS = {
  // add your flag default here
  isGoogleMapsApiKeyEnabled: false,
}

const state = {
  customerFlagsKey: '',
  allFlags: {
    ...DEFAULT_FLAGS,
  },
}

const getters = {
  featureFlags: (state) => {
    return state.allFlags
  },
}

const actions = {}

const mutations = {
  [SET_FEATURE_FLAGS](state, flags) {
    state.allFlags = flags
  },
  [SET_CUSTOMER_FLAGS_KEY](state, key) {
    state.customerFlagsKey = key
  },
  [RESET_FEATURE_FLAGS](state) {
    state.allFlags = { ...DEFAULT_FLAGS }
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
